import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { UserData } from "../../auth/Authorization";
import Pagination from "../../components/Paginate/Pagination";
import { imsLoader } from "../../assets";
import GenAIProjectItem from "./GenAIProjectItem";
import { GenAIAnsweringContext } from './GenAIAnsweringContextProvider';
import ConfirmMessagePopUpModal from "./../GenAIPopUp/ConfirmMessagePopUpModal"
import trackingService from "../../services/trackingService";
import AuthoringProjectService from "../../services/AuthoringProjectService";
import "./index.css"

let api = new AuthoringProjectService();
class GenAIProjectsList extends Component {
    static contextType = GenAIAnsweringContext;
    constructor(props) {
        super(props);
        this.state = {
            customWidth: props.customWidth,
            customHeight: props.customHeight,
            itemsPerPage: "10",
            currentPage: "1",
            documentCount: 0,
            isProcessing: false,
            openedContextMenuId: this.props.openedContextMenuId,
            confirmMessageContent: '',
            confirmMessageShowModal: false,
            confirmMessageId: -1,

        }
    }
    componentDidMount = async () => {
        await this.context.getExistingProjectLists();
    }
    handleOnOpenedContextMenuClick = (_id) => {
        this.setState({ openedContextMenuId: _id })
        // this.props.handleDeleteAllProjectshideMenu();
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.openedContextMenuId !== this.state.openedContextMenuId) {
            this.setState({ openedContextMenuId: nextProps.openedContextMenuId })
        }
    }
    handleOndeleteAnswerThreadIndexTrackingData = (sessionid) => {
        let genAiAnswer = {
            "session_id": sessionid,
        }
        const ts = new trackingService();
        ts.indexTrackingData(
            localStorage.getItem("userdisplayName"),
            localStorage.getItem("wwid"),
            localStorage.getItem("username"),
            localStorage.getItem("function"),
            localStorage.getItem("region"),
            localStorage.getItem("userproducts"),
            localStorage.getItem("doctypepref"),
            localStorage.getItem("sid"),
            localStorage.getItem("deviceType"),
            localStorage.getItem("deviceOS"),
            localStorage.getItem("browserName"),
            localStorage.getItem("browserVersion"),
            localStorage.getItem("jnjDepartment"),
            localStorage.getItem("companyname"),
            "Delete Project GenAIAuthering2.0",
            "",
            window.location.href, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
            {}, {}, genAiAnswer
        );
    }
     deleteAuthorProjectBySessionId = async (sessionid) => {
            this.context.updateLibraryThreadProcessing(true);
            if (UserData && UserData.sub) {
                await api.deleteAuthorProjectBySessionId(UserData.sub, sessionid)
                    .then(async (response) => {
                        this.handleOndeleteAnswerThreadIndexTrackingData(sessionid); 
                      })
                    .catch((error) => {
                        console.log(error);
                        this.context.updateLibraryThreadProcessing(false);
                    }).finally(() => {
                    this.setState(
                        {
                            isProcessing: false,
                        }, () => {
                            setTimeout(async () => {
                                await this.context.getExistingProjectLists();
                                this.context.updateLibraryThreadProcessing(false);
                            }, 600);

                        })
                });
            } else {
                this.setState(
                    {
                        isProcessing: false,
                    }, () => {
                        this.context.updateLibraryThreadProcessing(false);
                    })
            }
        }

    showConfirmMessage = (message, id) => {
        this.setState({
            confirmMessageContent: message,
            confirmMessageShowModal: true,
            confirmMessageId: id
        })
    }

    confirmHandler = async () => {
        this.setState(
            {

                confirmMessageContent: "",
                confirmMessageShowModal: false,
                // confirmMessageId: -1
            },
            async () => {
                // await this.deleteAllAnswerThreadDataByUser();
                this.setState({ confirmMessageId: -1 });
            }
        );
    }

    closeConfirmMessage = () => {
        this.setState({
            confirmMessageContent: "",
            confirmMessageShowModal: false,
            confirmMessageIndex: -1
        })
    }

    renderModeProjectHistory() {
        let { projectResponse } = this.context;
        return (<>
            {
                projectResponse.map((projectItem, projectIndex) => {
                     return (
                    <GenAIProjectItem
                        handleOnOpenedContextMenuClick={this.handleOnOpenedContextMenuClick}
                        deleteAuthorProjectBySessionId={this.deleteAuthorProjectBySessionId}
                        openedContextMenuId={this.state.openedContextMenuId}
                        source={projectItem._source}
                        key={`Project-History${projectItem._id}`} />
                    )
                })
            }
        </>)
    }
    render() {
        let { isProcessing, } = this.state;
        const { confirmMessageContent, confirmMessageShowModal } = this.state;
        let { projectDocumentCount, projectItemsPerPage, projectCurrentPage, projectResponse, isProjectProcessing } = this.context;
        if (this.props.customWidth >= 600 && this.props.customWidth <= 1000) {
            return (<></>)
        }
        else if (this.props.customWidth > 1000) {
            return (<div className="gen-ai-answering-library-threads-list-wrapper">
                {(isProcessing || isProjectProcessing) ?
                    <div style={{ textAlign: "center", marginBottom: "10px" }}>
                        <img src={imsLoader} alt="Loading Filters" style={{ width: "10%", marginTop: "200px" }} />
                    </div> :
                    projectResponse.length > 0 ? <>
                        <div className="gen-ai-answering-library-threads-lists">
                            <div>
                                {this.renderModeProjectHistory()}
                            </div>
                        </div>

                        <Pagination
                            metadata={projectDocumentCount}
                            handlePageChange={this.handlePageChange}
                            itemsPerPage={projectItemsPerPage}
                            page={parseInt(projectCurrentPage)}
                            customWidth={this.state.width}
                            customHeight={this.state.height}
                        />
                    </> : <div className="gen-ai-answering-library-threads-list">
                        <div className="gen-ai-answering-library-threads-list-no-threads">No Projects yet</div>
                    </div>
                }
                {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} />}
            </div>
            )
        }
    }

    handleNextClick = () => {
        try {
            if (
                this.state.currentPage <
                Math.ceil(this.state.documentCount / this.state.itemsPerPage)
            ) {
                // if (this.state.currentPage <= 1) {
                this.setState(
                    {
                        currentPage: parseInt(this.state.currentPage) + 1,
                    },
                    () => {
                        this.handlePageChange(this.state.currentPage);
                    }
                );
            }
        } catch (error) {
            this.setState({ error: error });
        }
    };
    handlePreviousClick = () => {
        try {
            if (this.state.currentPage >= 2) {
                this.setState(
                    {
                        currentPage: this.state.currentPage - 1,
                    },
                    () => {
                        this.handlePageChange(this.state.currentPage);
                    }
                );
            }
        } catch (error) {
            this.setState({ error: error });
        }
    };
    navigateToLastPage = () => {
        try {
            this.setState(
                {
                    currentPage: Math.ceil(
                        this.state.documentCount / this.state.itemsPerPage
                    ),
                },
                () => {
                    this.handlePageChange(this.state.currentPage);
                }
            );
        } catch (error) {
            this.setState({ error: error });
        }
    };
    navigateToFirstPage = () => {
        try {
            this.setState(
                {
                    currentPage: 1,
                },
                () => {
                    this.handlePageChange(this.state.currentPage);
                }
            );
        } catch (error) {
            this.setState({ error: error });
        }
    };
    handlePageChange = (currentPage) => {
        try {
            window.scrollTo({ behavior: "smooth", top: "0px" });
            this.setState(
                {
                    currentPage: currentPage,
                },
                async () => {
                    await this.context.updateProjectCurrentPage(currentPage);
                    await this.context.getExistingProjectLists();
                }
            );

        } catch (error) {
            this.setState({ error: error });
        }
    };

}
export default withRouter(GenAIProjectsList);
